// The vehicle's base colour (no finish: metallic, pearl…), chosen from a list.
// Same names as VEHICLE_COLORS in backend/business_rules.py, which accepts only these.
// Colours written by hand before the list existed are read through `pattern`
// ("Grigio met." is Grigio), so old vehicles still show their dot.

// Order matters for `pattern`: the more specific names come first.
const COLORS = [
  { name: "Grigio scuro", hex: "#4b5563", pattern: /grigio scuro|antracite|canna di fucile|piombo/ },
  { name: "Argento", hex: "#c0c4cc", pattern: /argent|silver|titanio/ },
  { name: "Grigio", hex: "#9ca3af", pattern: /grigi|grey|gray/ },
  { name: "Bianco", hex: "#f8fafc", pattern: /bianc|white|avorio/ },
  { name: "Nero", hex: "#111827", pattern: /\bner|black/ },
  { name: "Azzurro", hex: "#38bdf8", pattern: /azzurr|celest|turchese/ },
  { name: "Blu", hex: "#1d4ed8", pattern: /\bblu|blue/ },
  { name: "Bordeaux", hex: "#7f1d1d", pattern: /bordeaux|amaranto|vinaccia/ },
  { name: "Rosso", hex: "#dc2626", pattern: /ross|\bred\b/ },
  { name: "Verde", hex: "#15803d", pattern: /verd|green/ },
  { name: "Giallo", hex: "#facc15", pattern: /giall|yellow/ },
  { name: "Arancione", hex: "#f97316", pattern: /arancio|orange/ },
  { name: "Marrone", hex: "#78350f", pattern: /marron|brown|bronz|testa di moro/ },
  { name: "Beige", hex: "#d6c7a1", pattern: /beige|sabbia|crema/ },
  { name: "Oro", hex: "#ca8a04", pattern: /\boro\b|gold|champagne/ },
  { name: "Viola", hex: "#7e22ce", pattern: /viola|purple|lilla/ },
];

// The choices of the vehicle form, in the usual order.
export const VEHICLE_COLORS = ["Bianco", "Nero", "Grigio", "Grigio scuro", "Argento", "Blu", "Azzurro", "Rosso",
  "Bordeaux", "Verde", "Giallo", "Arancione", "Marrone", "Beige", "Oro", "Viola"].map((name) => COLORS.find((c) => c.name === name));

const normalize = (text) => String(text || "").toLocaleLowerCase("it-IT").normalize("NFD").replace(/[̀-ͯ]/g, "").trim();

/** The base colour of a stored value (a list name, or older hand-written text), or null. */
export function baseColor(text) {
  const value = normalize(text);
  if (!value) return null;
  return COLORS.find((c) => normalize(c.name) === value) || COLORS.find((c) => c.pattern.test(value)) || null;
}

export const colorSwatch = (text) => baseColor(text)?.hex || null;
